

export class Gallery {

  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.max      = parseInt(this.container.dataset.images, 10);
    this.current  = parseInt(this.container.dataset.index, 10);

    this.interval = Math.max(1000, parseInt(this.container.dataset.interval ?? 5000));

    this.container.gallery = this;
    this.container.addEventListener('click', this);
    this.thumbnails = [...this.container.querySelectorAll('ul li img')];

    this.first = this.container.querySelector('.full img.first');
    this.second = this.container.querySelector('.full img.second');

    setTimeout(() => this.start(), Math.random() * 2000)
  }

  start()
  {
    this.handle = setTimeout(() => { this.switch(); }, this.interval);
  }

  stop() {
    if (this.handle) {
      clearInterval(this.handle);
    }
  }

  switch() {
    this.update(this.current + 1);
    this.start();
  }

  update(index) {
    this.current = Math.max(1, index);
    if (this.current > this.max) {
      this.current = 1;
    }
    this.container.dataset.index = this.current;

    this.second.src = this.thumbnails[this.current - 1].src;

    this.second.classList.remove('second');
    this.second.classList.add('first');

    this.first.classList.add('second');
    this.first.classList.remove('first');
    const temp = this.first;
    this.first = this.second;
    this.second = temp;

  }

  handleEvent(e) {
    if (e.type !== "click") {
      return;
    }

    switch (e.target.tagName) {
      case "IMG":
        if (e.target.parentElement.classList.contains('full')) {
          this.next();
        } else {
          const index = this.thumbnails.indexOf(e.target);
          this.stop();
          this.update(index + 1);
          this.start();
        }
        break;
    }

  }

  next() {
    this.stop();
    this.update(this.current + 1);
    this.start();
  }
}
